import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "./co2";
import "./mapstation";
import "./quote-form";

import initArticle from "./article";
import initNews from "./news";

import initFloatingPhone from "./global/floating-phone";
import initHeaderScroll from "./global/header-scroll";
import initMegaMenu from "./global/mega-menu";
import initSimpleMegaMenu from "./global/mega-menu-simple";
import initMobileMenu from "./global/mobile-menu";
import initPromoBar from "./global/promo-bar";
import initNewsletterRecaptcha from "./global/recaptcha";

import initCapacityCards from "./components/capacity-cards";
import initContactFormTabs from "./components/contact-form-tabs";
import initContentVideo from "./components/content-video";
import initFaq from "./components/faq";
import initHero from "./components/hero";
import initHighlightAnimation from "./components/highlight-animation";
import initIconContentList from "./components/icon-content-list";
import initMediaContentVideo from "./components/media-content-video";
import initProductsByDomain from "./components/products-by-domain";
import initSectorsGrid from "./components/sectors-grid";
import initSolarSolutions from "./components/solar-solutions";
import initStackedSteps from "./components/stacked-steps";
import initStrategyGrid from "./components/strategy-grid";
import initTimeline from "./components/timeline";
import initVideoModal from "./components/video-modal";

import initFeaturedPostsCarousel from "./carousels/featured-posts";
import initGroupLogosCarousel from "./carousels/group-logos";
import initLatestArticlesCarousel from "./carousels/latest-articles";
import initLogoCarousel from "./carousels/logos";
import initMediaCarousel from "./carousels/media";
import initOffersCarousel from "./carousels/offers";
import initPagesCarousel from "./carousels/pages";
import initReviewsCarousel from "./carousels/reviews";
import initSolarCarousel from "./carousels/solar";
import initTestimonialsCarousel from "./carousels/testimonials";
import initUsageSolutionsCarousel from "./carousels/usage-solutions";
import initVisionCarousel from "./carousels/vision";
import initWhitepapersCarousel from "./carousels/whitepapers";

import initSectorsGridCarousel from "./carousels/sectors-grid";
import initMarketingPopup from "./marketing-popup";


document.addEventListener("DOMContentLoaded", () => {
    // Global
    initMobileMenu();
    initHeaderScroll();
    initPromoBar();
    initMegaMenu();
    initSimpleMegaMenu();
    initFloatingPhone();
    initNewsletterRecaptcha();

    // Components
    initHero();
    initProductsByDomain();
    initSectorsGrid();
    initStrategyGrid();
    initFaq();
    initStackedSteps();
    initContentVideo();
    initVideoModal();
    initMediaContentVideo();
    initContactFormTabs();
    initIconContentList();
    initSolarSolutions();
    initTimeline();
    initHighlightAnimation();
    initCapacityCards();

    // Carousels
    initOffersCarousel(Swiper, Navigation);
    initLatestArticlesCarousel(Swiper, Autoplay);
    initVisionCarousel(Swiper, Navigation, Autoplay);
    initSolarCarousel();
    initLogoCarousel();
    initFeaturedPostsCarousel();
    initUsageSolutionsCarousel(Swiper, Navigation, Autoplay);
    initWhitepapersCarousel();
    initPagesCarousel(Swiper, Navigation, Autoplay);
    initMediaCarousel(Swiper, Pagination);
    initGroupLogosCarousel(Swiper);
    initTestimonialsCarousel(Swiper, Pagination);
    initReviewsCarousel();
    initSectorsGridCarousel(Swiper, Navigation, Autoplay);

    // Modules déjà existants
    initNews();
    initArticle();

    initMarketingPopup();
});
